import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=35e772fe&scoped=true"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=35e772fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e772fe",
  null
  
)

export default component.exports